import React from "react";
import OwlCarousel from "react-owl-carousel";
import { BodyHeader30, BodyText12 } from "../../shared/fonts";

export default function Screenshot({ hasBg }) {
  const options = {
    loop: false,
    margin: 0,
    center: true,
    dots: true,
    nav: true,
    autoplay: false,
    responsive: {
      0: {
        items: 1,
      },
      768: {
        items: 2,
      },
      991: {
        items: 2,
      },
      1200: {
        items: 3,
      },
      1920: {
        items: 3,
      },
    },
  };
  return (
    <>
      <section
        id="projects"
        className={`screenshots-section ptb-100 ${
          hasBg ? "gray-light-bg" : ""
        }`}
      >
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-8">
              <div className="section-heading text-center">
                {hasBg ? (
                  <span className="text-uppercase color-secondary sub-title">
                    App Screenshots
                  </span>
                ) : (
                  ""
                )}
                <BodyHeader30 style={{marginBottom: '1.2rem'}}>Projects</BodyHeader30>
                <BodyText12>
                  Take a look at some of our projects
                </BodyText12>
              </div>
            </div>
          </div>
          <div className="screen-slider-content mt-5">
            <div className="screenshot-frame"></div>
            <OwlCarousel
              className="screen-carousel owl-carousel owl-theme dot-indicator"
              {...options}
            >
              <img
                src="assets/img/gapapp.png"
                alt="screenshots"
                style={{height: '18.8rem', marginTop: '1rem'}}
                />
              <img
                src="assets/img/blockis.png"
                alt="screenshots"
                style={{height: '18.8rem', marginTop: '1rem'}}

              />
              <img
                src="assets/img/viora.png"
                alt="screenshots"
                style={{height: '18.8rem', marginTop: '1rem'}}

              />
              <img
                src="assets/img/quizando.png"
                alt="screenshots"
                style={{height: '18.8rem', marginTop: '1rem'}}

              />
            </OwlCarousel>
          </div>
        </div>
      </section>
    </>
  );
}
